export default __webpack_public_path__ + "static/media/Instagram-wt.b4090e3d.svg";